import { extendTheme } from '@chakra-ui/react';

import MainPanelComponent from './additions/layouts/MainPanel';
import components from './components';
import foundations from './foundations';

export default extendTheme(
  foundations,
  MainPanelComponent,
  { components },
);
